// ÁRSOR-MEGJELENÍTÉS — a katalógus és a hozzárendelés-lista KÖZÖS ársor-nyelve.
//
// MIÉRT KÖZÖS: az ársorok (`unit`/`base`/`tier`/`overflow`/`minimum`/`passive`) ugyanazt jelentik a katalógus
// „Árazás" cellájában és a hozzárendelés-lista „Árazás" cellájában — a címke-képzés és a látható sorok
// darabszáma tehát EGY helyen éljen (a repo DRY-szabálya: a 2. előfordulásnál a közös rétegbe).
//
// A `t`-t a hívó adja (a modul i18n-agnosztikus), a kulcsok a `serviceCatalog.priceType.*` alatt élnek.
import { type TFunction } from 'i18next';

/** Egy ársor a megjelenítéshez szükséges mezőkkel (a contract-sorok szűkítése). */
export interface PriceRowLike {
  type: string;
  tierMin: number | null;
  tierMax: number | null;
  blockSize: number | null;
}

/**
 * Hány ársort mutat a LISTA-cella. A legacy csak az elsőt írta ki, a többit legördülőben — nálunk három sor a
 * kompromisszum: egy 11-sávos csomag (Hírlevél) így sem borítja fel a tábla ritmusát, a tipikus 1–3 sávos
 * árazás pedig teljesen látszik. A maradékot „+N további ársáv" jelzi.
 */
export const VISIBLE_PRICE_ROWS = 3;

/**
 * Az ársor BAL oldali címkéje (a legacy price-type megjelenítés 1:1): `tier` → „{min}-{max} db",
 * `overflow` → „/ {blokk} db", a többi a saját, lokalizált címkéje.
 */
export function priceRowLabel(pr: PriceRowLike, t: TFunction): string {
  const unit = t('serviceCatalog.blockUnit');
  switch (pr.type) {
    case 'tier':
      return `${pr.tierMin ?? 0}-${pr.tierMax ?? '∞'} ${unit}`;
    case 'overflow':
      return `/ ${pr.blockSize ?? ''} ${unit}`.replace(/\s+/g, ' ').trim();
    case 'passive':
      return t('serviceCatalog.priceType.passive');
    case 'minimum':
      return t('serviceCatalog.priceType.minimum');
    case 'base':
      return t('serviceCatalog.priceType.base');
    case 'unit':
      return t('serviceCatalog.priceType.unit');
    default:
      return pr.type;
  }
}
